module.exports = __webpack_public_path__ + "public/static/img/img-section2-11.93b031b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-section2-11.svg
// module id = LJb7
// module chunks = 1